import { axiosPrivate } from "../../api/axios";
import { Container, Modal, Row, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

const RemoveUserModal = ({
  open,
  onClose,
  vendorId,
  usersName,
  usersLastName,
  usersEmail,
  userId,
}) => {
  if (!open) return null;
  const controller = new AbortController();

  const removeUser = async (vendorId, userId) => {
    try {
      const response = await axiosPrivate.post(
        `removeUser?vendorId=${vendorId}&userId=${userId}`,
        {
          signal: controller.signal,
        }
      );
      toast.success(response.data);
    } catch (err) {
      toast.error(err.message);
    }
    setTimeout(() => {
      onClose();
    }, 3000);
  };

  return (
    <div>
      <Modal show={open} onHide={onClose} role="dialog">
        <Modal.Header>
          <Modal.Title>Odstranjevanje uporabnika</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <p>
                <strong>Želite odstraniti uporabnika iz podjetja?</strong>
              </p>
              <p>
                {usersName}, {usersLastName}, {usersEmail}
              </p>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            variant="success"
            onClick={() => removeUser(vendorId, userId)}
          >
            Odstrani
          </Button>{" "}
          <Button type="button" variant="danger" onClick={onClose}>
            Prekliči
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer autoClose={3000} position="top-right" theme="light" />
    </div>
  );
};

export default RemoveUserModal;
